







import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { AppModule } from "@/store/modules/app"
import StepComponent from "@/components/common/StepComponent.vue"


export default abstract class StepContent extends Vue {
    @Prop({})
    activeComponentName!: string
    @Prop({})
    stepData!: object
    @Prop({})
    optional!: boolean

    $refs!: {
        activeComponent: StepComponent
    }
    
    abstract onCancel():void
    abstract onConfirm():void
    abstract onError(message:string):void
    abstract goToMenu():void

}
